import React, { useState, useEffect } from 'react';
import Cases from '../components/Cases/Cases';
import Faq from '../components/Main/Faq';
import Footer from '../components/Main/Footer';
import Video from '../components/Main/Video';
import Files from '../components/Main/FilesForPayment';
import Card from '../components/Cases/Card';
import Title from '../components/Cases/Title';
import { BACKEND_URL } from '../consts';

const App = () => {
  const [data, setData] = useState([]); // Инициализация как пустой массив
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // const BASE_URL =`http://v2691254.hosted-by-vdsina.ru/api/v1/block/cases`; // Используем ID в URL
  const BASE_URL = `${BACKEND_URL}/api/v1/block/cases`; // Используем ID в URL

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(BASE_URL);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const fetchedData = await response.json();
        
        // Логируем данные для проверки
        console.log(fetchedData);

        // Проверяем, является ли fetchedData массивом
        if (Array.isArray(fetchedData)) {
          setData(fetchedData);
        } else {
          throw new Error('Fetched data is not an array');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      {data.map((block, index) => {
        if (block.type === "header_block") {
          return <Title key={index} data={block.payload} />;
        }
        if (block.type === "card_block") {
          return <Card key={index} data={block.payload} />;
        }
        if (block.type === "video_block") {
          return <><Video key={index} data={block.payload} /><Files/></>;
        }
        if (block.type === "faq_block") {
          return <Faq key={index} data={block.payload} />;
        }
        if (block.type === "footer_block") {
          return <Footer key={index} data={block.payload} />;
        }
        return null; // Возвращаем null для других типов блоков
      })}
    </>
  );
};

export default App;
